document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".announcement-bar-slider-wrap", {
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
    });
});